<template>
    <Head>
        <title>{{ `${page.title} - AutoBesikos `}}</title>
        <meta name="description" :content="page.meta_description">
    </Head>

    <PopupSmall :id="2">
        <div class="warranty-popup">
            <h2>Τι περιλαμβάνει η Μονοετής (1 έτος/20.000 χλμ.) Εγγύηση Μεταχειρισμένου της AutoBesikos</h2>
            <p>
                Η Εγγύηση έχει έναρξη από την ημερομηνία παραλαβής του οχήματος από τον πελάτη και ισχύει μόνο όσο βρίσκεται στην κατοχή του συγκεκριμένου ιδιοκτήτη.
            </p>
            <p>
                Το πρόγραμμα καλύπτει το κόστος των ανταλλακτικών και της εργασίας μόνο για συγκεκριμένα μηχανικά μέρη όπως την επισκευή εσωτερικά του κινητήρα, του κιβωτίου ταχυτήτων και του διαφορικού.
            </p>
            <h2>Δεν περιλαμβάνει:</h2>
            <p>
                Περιφερειακά μέρη του κινητήρα (μίζα, δυναμό, μπεκ καυσίμου, αντλία καυσίμου, κομπρεσέρ A/C, ρουλεμάν και τεντωτήρες ιμάντα, τους εξωτερικούς ιμάντες, όλους τους αισθητήρες, την τουρμπίνα, τον καταλύτη και το φίλτρο μικροσωματιδίων DPF), τα περιφερειακά μέρη του κιβωτίου ταχυτήτων (αντλίες συμπλέκτη, σετ αμπραγιάζ, βολάν) και του διαφορικού (ημιαξόνια, φούσκες ημιαξονίου).
            </p>
            <p>
                Επιπλέον, δεν καλύπτει τις ηλεκτρονικές μονάδες και τις καλωδιώσεις του κινητήρα, του κιβωτίου ταχυτήτων και της καμπίνας, τα υλικά τριβής(τακάκια και δισκόπλακες), το κύκλωμα φρένων (αντλία ABS, αντλίες φρένων και σωληνάκια) και το σύστημα διεύθυνσης (κρεμαργιέρα, ακρόμπαρα, κολώνα τιμονιού).
            </p>
            <h2>Όροι και Προϋποθέσεις:</h2>
            <p>
                Η Εγγύηση αφορά οχήματα στα οποία δεν έχει παρέλθει η 8ετία από την 1η άδεια κυκλοφορίας τους, με έως 80.000 χλμ.
            </p>
            <p>
                Η Εγγύηση έχει ισχύ εφόσον το αυτοκίνητο έχει ασφαλιστεί σε συνεργαζόμενα με την AutoBesikos <a href="/insurance" title="insurance">ασφαλιστικά πρακτορεία</a> καθ’ όλη την διάρκεια της εγγυήσεως.
            </p>
            <p>
                Η Εγγύηση έχει ισχύ εφόσον το αυτοκίνητο συντηρείται σύμφωνα με το πρόγραμμα τακτικών συντηρήσεων με όλα τα προγραμματισμένα προς αντικατάσταση ανταλλακτικά και τις εργασίες που πρέπει να γίνουν ανά 20.000χλμ ή κάθε χρόνο (όποιο επέλθει πρώτο), βάσει του πίνακα προγραμματισμένης συντήρησης σε <a href="/service" title="Service">συνεργεία</a> της AutoBesikos.
            </p>
            <p>
                Δεν αναγνωρίζεται αίτημα επιστροφής ή συμψηφισμός χρημάτων για πραγματοποίηση επισκευής των καλυπτόμενων μερών σε οποιοδήποτε άλλο συνεργείο εκτός της AutoBesikos για το διάστημα που καλύπτεται από την Δωρεάν Εγγύηση.
            </p>
        </div>
    </PopupSmall>

    <div class="single-base">
        <section class="single-head">
            <Link href="/">Αρχική σελίδα</Link>
            <p>/</p>
            <h1>{{ page.title }}</h1>
        </section>
        <section class="single-hero">
            <img v-if="page.media[0]" :src="page.media[0].original_url" :alt="page.media[0].name" width="1920" height="535" />
            <div v-if="this.page.form_position === 'float' || this.page.form_position === 'model' || this.page.form_position === 'bottom'" class="single-hero-text">
                <h2>{{ page.title }}</h2>
            </div>
        </section>
        <div class="single-float">
            <div>
                <Button anchor inline href="#page-form">Επικοινωνία</Button>
            </div>
        </div>    
        <div v-if="this.page.form_position === 'float' || this.page.form_position === 'model' || this.page.form_position === 'bottom'" class="single-main">
            <div :class="this.page.form_position === 'float' || this.page.form_position === 'model' ? 'single-info single-info-float' : 'single-info'">
                <div id="gjs-page-main" v-if="page.gjs_data" v-html="page.gjs_data.html"></div>
                <section v-if="page.form_position === 'float' || page.form_position === 'model'" id="page-form" class="single-form mobile-only">
                    <h2>Φόρμα εκδήλωσης ενδιαφέροντος</h2>
                    <FormSimple v-if="page.form_position === 'float'" :page="page.title" />
                    <FormModel v-if="page.form_position === 'model'" :page="page.title" />
                </section>
            </div>
            <aside v-if="page.form_position === 'float' || page.form_position === 'model'" class="single-aside desktop-only">
                <div class="single-aside-main form-main">
                    <h2>Φόρμα εκδήλωσης ενδιαφέροντος</h2>
                    <FormSimple v-if="page.form_position === 'float'" :page="page.title" />
                    <FormModel v-if="page.form_position === 'model'" :page="page.title" />
                </div>
            </aside>
        </div>
        <div id="gjs-page-main" v-if="this.page.form_position === 'none' || this.page.form_position === 'expo'" v-html="page.gjs_data.html"></div>
        <section v-if="$global.current_url.includes('online-agora')" class="single-new-cars">
            <div class="home-heading">
                <h2>Ανακάλυψε τώρα μεταχειρισμένα αυτοκίνητα έτοιμα για online αγορά</h2>
            </div>
            <SliderNewCars :cars="$attrs.latestCars.data" :user="$attrs.auth.user" @favorite_car="updateFavorites" />
            <div class="single-new-cars-button">
                <Button inline href="/vehicles">Δες περισσότερα αυτοκίνητα</Button>
            </div>
        </section>
        <section v-if="page.form_position === 'bottom'" class="page-form" id="form-interest" :class="$global.current_url.includes('online-agora') ? 'single-form-alter' : ''">
            <div class="vehicle-heading">
                <h2>{{ $global.current_url.includes('online-agora') ? 'Θέλεις σήμερα να αποκτήσεις το νέο σου Αυτοκίνητο; Μη χάσεις την ευκαιρία - Επικοινώνησε μαζί μας.' : 'Φόρμα εκδήλωσης ενδιαφέροντος' }}</h2>
            </div>
            <div class="vehicle-form-main">
                <FormVehicle interestFor="ασφάλεια" :page="page.title" bottom />
            </div>
        </section>
        <section v-if="page.form_position === 'expo'" class="page-form" id="form-expo">
            <div class="vehicle-heading">
                <h2>Συμπλήρωσε τη φόρμα και θα σε ενημερώσουμε για το μεταχειρισμένο που σε ενδιαφέρει!</h2>
            </div>
            <div class="vehicle-form-main">
                <FormExpo :page="page.title" bottom />
            </div>
        </section>
        <section v-if="$global.current_url.includes('about')" class="about-us-map">
            <h2>Βρείτε μας στον χάρτη</h2>
            <Map />
        </section>
    </div>

    <div class="single-floater">
        <Button anchor inline href="#form-interest">Επικοινωνία</Button>
    </div>

    <!-- Favorites -->
    <RefreshPageFavorites :user="$attrs.auth.user" :favorites_cars="favorites_cars" :favorites_cars_trigger="favorites_cars_trigger" @postChange="triggerFavorite" />
    <!-- End Favorites -->
</template>

<script>
    import Button from '../Components/Button/Button.vue';
    import FormSimple from '../Components/Form/FormSimple.vue';
    import FormVehicle from '../Components/Form/FormVehicle.vue';
    import FormModel from '../Components/Form/FormModel.vue';
    import Map from '../Components/Map/Map.vue';
    import PopupSmall from '../Components/Popup/PopupSmall.vue';
    import FormExpo from '../Components/Form/FormExpo.vue';
    import SliderNewCars from "../Components/Slider/SliderNewCars.vue";
    import RefreshPageFavorites from "../Components/LocalStorage/RefreshPageFavorites.vue";

    export default {
        components: {
            FormSimple, FormVehicle, Button, FormModel, Map, PopupSmall, FormExpo, SliderNewCars,
        },
        props: {
            page: Object
        },
        data() {
            return {
                update_favorites: 0,
                favorites_cars: [],
                favorites_cars_trigger: false,
                searchValue: '/vehicles',
                open: false,
            }
        },
        provide() {
            return {
                // reactive global provider
                updateFavorites: this.update_favorites,
            }
        },
        methods: {
            floatNav() {
                const stick = window.pageYOffset || document.documentElement.scrollTop || window.scrollTop;
                const ParentElement = document.querySelector(".single-base");
                const childElement = document.querySelector(".single-floater");
                const formElement = document.querySelector(".page-form");
                const menuHeight = document.querySelector(".header");

                let parentElementTop = ParentElement.offsetTop + 50;
                let currentHeight = (stick ?? 0) + menuHeight.offsetHeight;
                let formElementTop = formElement.offsetTop - window.innerHeight + menuHeight.offsetHeight;

                if ( this.$global.isMobile ) {
                    if ( currentHeight >= parentElementTop && currentHeight < formElementTop ) {
                        childElement.classList.add("single-floater-active");
                    } else {
                       childElement.classList.remove("single-floater-active");
                    }
                }
            },
            stickyNav() {
                const stick = window.pageYOffset || document.documentElement.scrollTop || window.scrollTop;
                const ParentElement = document.querySelector(".single-main");
                const childElement = document.querySelector(".single-aside-main");
                const menuHeight = document.querySelector(".header").offsetHeight;
                
                let parentElementTop = ParentElement.offsetTop;
                let currentHeight = stick + menuHeight + 80;
                let parentElementHeight = ParentElement.offsetTop + ParentElement.offsetHeight;
                let childElementHeight = childElement.offsetHeight;
                
                if ( currentHeight >= parentElementTop && currentHeight < parentElementHeight - childElementHeight ) {
                    childElement.classList.add("single-aside-main-sticky");
                    childElement.classList.remove("single-aside-main-absolute");
                } else if ( currentHeight + 80 >= parentElementHeight - childElementHeight ) {
                    childElement.classList.remove("single-aside-main-sticky");
                    childElement.classList.add("single-aside-main-absolute");
                } else {
                    childElement.classList.remove("single-aside-main-sticky");
                    childElement.classList.remove("single-aside-main-absolute");
                }

                const mobileElement = document.querySelector(".single-float");
                const singleForm = document.querySelector(".single-form");

                if ( stick >= menuHeight && currentHeight <= singleForm.offsetTop - menuHeight - 120 ) {
                    mobileElement.classList.add("single-float-fixed");
                } else {
                    mobileElement.classList.remove("single-float-fixed");
                }
            },
            triggerPopup(value, id) {
                this.$global.popup.open = value;
                this.$global.popup.id = id;
            },
            triggerFavorite(value) {
                // Observe the window changes and re-calculate the active favorites
                this.favorites_cars_trigger = value;
                this.favorites_cars.length = 0;
            },
            updateFavorites(id) {
                // Update the array
                if ( !this.favorites_cars.includes(id) ) {
                    this.favorites_cars.push(id);
                } else {
                    const index = this.favorites_cars.indexOf(id);
                    if ( index > -1 ) {
                        this.favorites_cars.splice(index, 1);
                    }
                }

                // Update between tabs - browser
                if ( this.favorites_cars.length > 0 ) {
                    this.favorites_cars_trigger = true;
                } else {
                    this.favorites_cars_trigger = false;
                }
            },
        },
        mounted() {
            // Dark side
            let self = this;

            if (this.page.form_position === 'float' || this.page.form_position === 'model') {
                window.addEventListener("scroll", this.stickyNav);
            }

            if ( this.$global.current_url.includes('online-agora') ) {
                window.addEventListener("scroll", this.floatNav);
            }

            if ( document.querySelector('.gjs-cell.disclosure-title') ) {
                const disclosuresTitles = document.getElementsByClassName('disclosure-title');
                const disclosuresText = document.getElementsByClassName('disclosure-text');
                const disclosuresIcon = document.getElementsByClassName('disclosure-icon');

                for (let i = 0; i < disclosuresTitles.length; i++) {
                    disclosuresTitles[i].onclick = function() {
                        disclosuresText[i].classList.toggle('disclosure-text-open');
                        disclosuresIcon[i].classList.toggle('disclosure-icon-open');
                    }
                }
            }
            
            if ( document.querySelector('.single-trigger-small-pop-up') ) {
                document.querySelector('.single-trigger-small-pop-up').onclick = function() { 
                    self.triggerPopup(true, 2);
                }
            }
        },
        beforeUnmount() {
            if ( this.page.form_position === 'float' || this.page.form_position === 'model' ) {
                window.removeEventListener("scroll", this.stickyNav);
            }
            if ( this.$global.current_url.includes('online-agora') ) {
                window.removeEventListener("scroll", this.stickyNav);
            }
            if ( this.favorites_cars.length > 0  ) {
                axios.post(`${this.$global.origin}/account/favorites`, { ids: this.favorites_cars }).then((data) => { return data });
            }
        },
    }
</script>